import { render } from "./SetAccounts.vue?vue&type=template&id=7948b1ac&scoped=true"
import script from "./SetAccounts.vue?vue&type=script&lang=js"
export * from "./SetAccounts.vue?vue&type=script&lang=js"

import "./SetAccounts.vue?vue&type=style&index=0&id=7948b1ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7948b1ac"]])

export default __exports__